import { Box, Gap, Icon, Tooltip } from '@salecycle/ui-component-library';
import UserLink from 'core/ui/components/userLink';
import moment from 'moment-timezone';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { generatePath } from 'react-router';
import { Link, useParams } from 'react-router-dom';
import { StateBadge } from 'sections/offsite-campaigns/components/StateBadge';
import { IOffsiteCampaign } from 'sections/offsite-campaigns/entities/offsiteCampaign';
import { campaignTypeToIcon } from 'sections/offsite-campaigns/offsite-campaign-editor/utils/campaignTypeToIcon';
import { OffsiteCampaignRoute } from 'sections/offsite-campaigns/routes/offsite-campaign-routes';
import { getFormattedTimeRange } from 'sections/utils/time-range';
import { CampaignsListItemActionsButton } from './CampaignsListItemActionsButton';
import { StyledCampaignListItem, StyledCircleBadge } from './styles';
import { FeatureTypes } from 'entities/campaign/features';

interface IProps {
  campaign: IOffsiteCampaign;
  timezone: string;
}

const OffsiteCampaignListItem: FC<IProps> = ({ campaign, timezone }) => {
  const { t } = useTranslation('campaigns');
  const { siteId } = useParams<{ siteId: string }>();
  return (
    <StyledCampaignListItem data-testid="CampaignListItem">
      <div>
        <h3>
          <Link to={generatePath(OffsiteCampaignRoute.OFFSITE_EDIT, { siteId, campaignId: campaign.id })}>
            {campaign.name}
          </Link>
        </h3>
        <p>{getFormattedTimeRange(campaign.startTime, campaign.endTime, timezone, t)}</p>
        <p className="last-edit">
          <UserLink
            id={campaign.updatedById}
            suffix={t('campaigns:lastEditBy')}
            placeholder={t('campaigns:lastEdit')}
          />{' '}
          {moment(campaign.updatedAt)
            .tz(timezone)
            .fromNow()}
        </p>
        <Gap top={25} />
        <Box>
          <StateBadge lifeCycle={campaign} />
          <Gap right={12} />
          {campaign.type && (
            <div>
              <Tooltip html={FeatureTypes[campaign.type]} distance={15}>
                <StyledCircleBadge>
                  <Icon icon={campaignTypeToIcon(campaign.type)} />
                </StyledCircleBadge>
              </Tooltip>
            </div>
          )}
        </Box>
      </div>
      <CampaignsListItemActionsButton campaign={campaign} />
    </StyledCampaignListItem>
  );
};

export default OffsiteCampaignListItem;
